import RestAPI from '../../../components/Common/restApi';

export default class OrganizationBetaFeaturesApi {
  static updateBetaFeature(featureName, active) {
    return RestAPI.updateWithFormData(`/alpha/organization/beta_features/${featureName}`, active);
  }

  static status(featureName) {
    return RestAPI.get(`/alpha/organization/beta_features/${featureName}/status`);
  }
}
